export const COMMUNITY_SERVER_ID = '00000000-0000-0000-0000-000000000001';
export const COMMUNITY_SERVER_NAME = 'Disenchantment';
//# sourceMappingURL=community.js.map